
<div class="filter_state">
  <div class="filter_state__tab all_work" (click)="filter_state('all_work')" [ngClass]="{'active': formGroup.value.tab === 'all_work'}">
    Все в работе ({{data.all_work}})
  </div>
  <div class="filter_state__tab done" (click)="filter_state('done')" [ngClass]="{'active': formGroup.value.tab === 'done'}">
    Подтверждены ({{data.done}})
  </div>
  <div class="filter_state__tab fail mr-2r" (click)="filter_state('fail')" [ngClass]="{'active': formGroup.value.tab === 'fail'}">
    Отклонены ({{data.fail}})
  </div>
  <div class="filter_state__create mr-2r">
    <form [formGroup]="formGroup" novalidate>
      <div class="row no-gutters gutters-0">
        <div class="col-sm-6">
          <app-material-input-datepicker formControlName="date_start" [cssClass]="'mb-0'" [placeholder]="'Резерв с'">
          </app-material-input-datepicker>
        </div>
        <div class="col-sm-6">
          <app-material-input-datepicker formControlName="date_end" [cssClass]="'mb-0'" [placeholder]="'Резерв до'">
          </app-material-input-datepicker>
        </div>
      </div>
    </form>
  </div>
  <div class="filter_state__create">
    <form [formGroup]="formGroup" novalidate>
      <div class="row no-gutters gutters-0">
        <div class="col-sm-6">
          <app-material-input-datepicker formControlName="date_change_start" [cssClass]="'mb-0'" [placeholder]="'Изменён с'">
          </app-material-input-datepicker>
        </div>
        <div class="col-sm-6">
          <app-material-input-datepicker formControlName="date_change_end" [cssClass]="'mb-0'" [placeholder]="'Изменён до'">
          </app-material-input-datepicker>
        </div>
      </div>
    </form>
  </div>
</div>

Всего: <b>{{theadline.showed_lines}}</b>
<div class="material-datatable-wrapper table-color">
  <app-datatable-headline
    [global_search_string]="global_search_string"
    [items_per_page_vars]="items_per_page_vars"
    (items_per_page_change)="itemPerPageChange($event)"
    (global_search_change)="onGlobalSearch($event)">
  </app-datatable-headline>
  <div class="table-responsive">
    <table class="table datatable table-rwd">
      <thead app-data-table-head
        [sort]="sort"
        [columns]="columns"
        (sort_emmit)="onSortChange($event)">
      </thead>
      <tbody app-data-table-body
        (rowClick)="rowClick.emit($event)"
        [columns]="columns"
        [rowClass]="'tab'">
      </tbody>
    </table>
  </div>
  <app-datatable-pagination
    [current_page]="current_page"
    (change_page)="changePage($event)">
  </app-datatable-pagination>
</div>

<ng-template #operation_create_dateHead let-row="row" let-ind="row_index">
  <form [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="operation_create_date" [cssClass]="'mb-0'" [placeholder]="'Дата резерва'">
    </app-material-input>
  </form>
</ng-template>
<ng-template #operation_end_dateHead let-row="row" let-ind="row_index">
  <form [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="operation_end_date" [cssClass]="'mb-0'" [placeholder]="'Окончание резерва'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #physical_subagent_fioTmpl let-row="row" let-ind="row_index">
  <div [ngClass]="{'activeBox': goBack.activeHash === 'physical_subagent_fio-' + ind}">
    <a href="/physical/edit/{{row.physical_subagent_id}}"
      (click)="goBack.newLink('/physical/edit/' + row.physical_subagent_id, 'physical_subagent_fio-' + ind, $event)">
      {{row.physical_subagent_fio}}
    </a>
  </div>
</ng-template>

<ng-template #object_captionTmpl let-row="row" let-ind="row_index">
  <div [ngClass]="{'activeBox': goBack.activeHash === 'object_caption-' + ind}">
    <a href="/housing2/flat/{{row.realty_flat_id}}"
      (click)="goBack.newLink('/housing2/flat/' + row.realty_flat_id, 'object_caption-' + ind, $event)">
      {{row.object_caption}}
    </a>
  </div>
</ng-template>

<ng-template #subagent_captionTmpl let-row="row" let-ind="row_index">
  <div [ngClass]="{'activeBox': goBack.activeHash === 'subagent_caption-' + ind}">
    <a href="/entity/edit/{{row.subagent_entity_id}}"
      (click)="goBack.newLink('/entity/edit/' + row.subagent_entity_id, 'subagent_caption-' + ind, $event)">
      {{row.subagent_caption}}
    </a>
  </div>
</ng-template>

<ng-template #physical_manager_fioTmpl let-row="row" let-ind="row_index">
  <div [ngClass]="{'activeBox': goBack.activeHash === 'physical_manager_fio-' + ind}">
    <a href="/managers/edit/{{row.physical_manager_id}}"
      (click)="goBack.newLink('/managers/edit/' + row.physical_manager_id, 'physical_manager_fio-' + ind, $event)">
      {{row.physical_manager_fio}}
    </a>
  </div>
</ng-template>

<ng-template #appeal_client_fioTmpl let-row="row" let-ind="row_index">
  @if (row.lead_id !== '') {
    <div [ngClass]="{'activeBox': goBack.activeHash === 'appeal_client_fio-' + ind}">
      <a [routerLink]="['/reservation/lead-info', row.lead_id]"
        (click)="goBack.newLink('/reservation/lead-info/' + row.lead_id, 'appeal_client_fio-' + ind, $event)">
        {{row.appeal_client_fio}}
      </a>
    </div>
  }
  @if (row.lead_id === '') {
    {{row.appeal_client_fio}}
  }
</ng-template>


<ng-template #housing_complex_captionHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="housing_complex_caption" [cssClass]="'mb-0'" [placeholder]="'Название ЖК'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #object_captionHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="object_caption" [cssClass]="'mb-0'" [placeholder]="'Квартира'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #physical_subagent_fioHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="physical_subagent_fio" [cssClass]="'mb-0'" [placeholder]="'Субагент'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #subagent_captionHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="subagent_caption" [cssClass]="'mb-0'" [placeholder]="'Организация'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #physical_subagent_phoneHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="physical_subagent_phone" [cssClass]="'mb-0'" [placeholder]="'Тел. субагента'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #appeal_client_fioHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="appeal_client_fio" [cssClass]="'mb-0'" [placeholder]="'Клиент'">
    </app-material-input>
  </form>
</ng-template>
<ng-template #appeal_client_phoneHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="appeal_client_phone" [cssClass]="'mb-0'" [placeholder]="'Тел. клиента'">
    </app-material-input>
  </form>
</ng-template>
<ng-template #physical_manager_fioHead let-row="row">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="physical_manager_fio" [cssClass]="'mb-0'" [placeholder]="'Ответственный'">
    </app-material-input>
  </form>
</ng-template>

<ng-template #stage_captionHead>
  <form [formGroup]="formGroup" novalidate>
    <app-material-input formControlName="stage_caption" [cssClass]="'mb-0'" [placeholder]="'Этап'">
    </app-material-input>
  </form>
</ng-template>
<ng-template #stage_captionTmpl let-row="row">
  <app-stages-dots [data]="row.stage_information"></app-stages-dots>
</ng-template>
